import axios from "axios";
const client = axios.create({
  withCredentials: true,
});
export const toQueryString = (obj: any) => {
  if (!obj) return "";

  obj = JSON.parse(JSON.stringify(obj));

  const query = "?".concat(
    Object.keys(obj)
      .map((e) =>
        obj[e] !== undefined
          ? `${encodeURIComponent(e)}=${encodeURIComponent(obj[e])}`
          : null,
      )
      .filter((e) => !!e)
      .join("&"),
  );

  return query;
};

export const getHeaders = (tokenReqd = true) => {
  const token = localStorage.getItem("token");

  let referer: string = "";
  if (process.env.VERCEL && process.env.VERCEL === "1") {
    referer = "vercel";
  }

  let headers: { [k: string]: any } = {
    "Content-Type": "application/json",
  };
  if (token && tokenReqd) {
    headers = { ...headers, Authorization: `Bearer ${token}` };
  }

  return headers;
};

/**
 * Turns an axios failure into the `{ success, error }` envelope the app expects.
 *
 * A rejected upload used to surface as the raw axios text ("Network Error"),
 * because the server's message was only unwrapped for 400 and 403. Any status
 * that carries the envelope now returns it, and the two upload-specific
 * failures — 413, and a connection dropped by a proxy body cap — get messages
 * that say what actually went wrong.
 */
const toErrorResponse = (error: any, isUpload = false) => {
  const { message, response } = error;

  if (response && response.status === 401) {
    localStorage.removeItem("token");
    window.location.reload();
    return { success: false, error: "Please login" };
  }

  const data = response?.data;
  if (
    data &&
    typeof data === "object" &&
    ("success" in data || "error" in data)
  )
    return data;

  if (response && response.status === 413) {
    return {
      success: false,
      error:
        "Attachment too large for the server. Videos must be under 30 MB, images and documents under 10 MB.",
    };
  }

  if (!response) {
    return {
      success: false,
      error: isUpload
        ? "Upload failed — the connection dropped, possibly because the attachment is too large. Check your connection and retry."
        : "Could not reach the server. Check your internet connection and retry.",
    };
  }

  return {
    success: false,
    error: message + (response ? `(${response?.statusText})` : ""),
  };
};

export const fetchPost = async (
  url: string,
  data: object,
  headers?: object,
  config?: object,
) => {
  try {
    const res = await client.post(url, data, {
      ...config,
      headers: { ...getHeaders(), ...headers },
    });

    if (res.status === 401) {
      localStorage.removeItem("token");
      // window.history.pushState({}, "", "/login");
      window.location.reload();
    }

    return res.data;
  } catch (error: any) {
    return toErrorResponse(error, data instanceof FormData);
  }
};
export const fetchPut = async (
  url: string,
  data: object,
  headers?: object,
  config?: object,
) => {
  try {
    const res = await client.put(url, data, {
      ...config,
      headers: { ...getHeaders(), ...headers },
    });

    return res.data;
  } catch (error: any) {
    return toErrorResponse(error, data instanceof FormData);
  }
};

export const fetchGet = async (url: string, headers?: object) => {
  try {
    const res = await client.get(url, {
      headers: { ...getHeaders(), ...headers },
    });

    return res.data;
  } catch (error: any) {
    return toErrorResponse(error);
  }
};
export const fetchDelete = async (
  url: string,
  data?: object,
  headers?: object,
) => {
  try {
    const res = await client.delete(url, {
      headers: { ...getHeaders(), ...headers },
    });

    return res.data;
  } catch (error: any) {
    return toErrorResponse(error);
  }
};

export const getCashFreeHeaders = (tokenReqd = true) => {
  const token = localStorage.getItem("token");

  let referer: string = "";
  if (process.env.VERCEL && process.env.VERCEL === "1") {
    referer = "vercel";
  }

  let headers: { [k: string]: any } = {
    "Content-Type": "application/json",
    "x-client-id": "CF877277D22E7HSVH4VS738C9LU0",
    "x-client-secret": "cfsk_ma_prod_5b05da145e3b01c1d6cab01219e13377_74d891dc",
  };
  if (token && tokenReqd) {
    headers = { ...headers, Authorization: `Bearer ${token}` };
  }

  return headers;
};

export const fetchPostCashfree = async (
  url: string,
  data: object,
  headers?: object,
  config?: object,
) => {
  try {
    const res = await client.post(url, data, {
      ...config,
      headers: { ...getCashFreeHeaders(), ...headers },
    });

    if (res.status === 401) {
      localStorage.removeItem("token");
      // window.history.pushState({}, "", "/login");
      window.location.reload();
    }

    return res.data;
  } catch (error: any) {
    const { message, response, request } = error;

    if (response && response.status === 401) {
      localStorage.removeItem("token");
      // window.history.pushState({}, "", "/login");
      window.location.reload();
      // window.location.reload();
      return { success: false, error: "Please login" };
    } else if (response && response.status === 400) return response.data;
    else if (response && response.status === 403) return response.data;
    return {
      success: false,
      error: message + (response ? `(${response?.statusText})` : ""),
    };
  }
};
